import { Button } from '../../catalyst/button';

export type ToggleOption<T> = { value: T; label: string; hotkey: string; disabled?: boolean };

/** A labelled row of choice buttons; the chosen one is filled and `aria-pressed`. */
export function ToggleGroup<T extends string | boolean>({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: ToggleOption<T>[];
  value: T | null;
  onChange: (value: T) => void;
}) {
  return (
    <div role="group" aria-label={label} className="space-y-1.5">
      <p className="text-sm font-medium text-gray-900 dark:text-zinc-100">{label}</p>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => {
          const content = (
            <>
              {o.label}
              <kbd className="ml-1 text-xs opacity-60">{o.hotkey}</kbd>
            </>
          );
          return value === o.value ? (
            <Button key={String(o.value)} color="indigo" aria-pressed={true} disabled={o.disabled} onClick={() => onChange(o.value)}>
              {content}
            </Button>
          ) : (
            <Button key={String(o.value)} outline aria-pressed={false} disabled={o.disabled} onClick={() => onChange(o.value)}>
              {content}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
